import script from "./SidenavCollapse.vue?vue&type=script&setup=true&lang=js"
export * from "./SidenavCollapse.vue?vue&type=script&setup=true&lang=js"

import "./SidenavCollapse.vue?vue&type=style&index=0&id=2c68d8da&lang=css"

const __exports__ = script;

export default __exports__